export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher100_dt@2x.b61b695c.png";